import { createAPI } from '@common'

export default {
  // 查询根栏目
  getColumnRoots: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sppu', 'get', config),
  // 查询子栏目
  getColumns: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct', 'get', config),
  // 删除栏目
  deleteColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0efmfuf', 'delete', config),
  // 复制栏目
  postColumnCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0dpqz', 'post', config),
  // 选择模板
  selectTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbufsfmt0sfm', 'post', config),
  getZipTemplateDetial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0{jqUfnqmbufEfujbm', 'get', config),
  // 查询栏目开启状态
  postTemplateStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbufsfmt0ibt0pqfo', 'post', config, {
      neverLoading: true
    }),
  // 启用模板
  templateOpen: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbufsfmt0pqfo', 'post', config),
  // 停用模板
  templateClose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbufsfmt0dmptf', 'post', config),
  // 查询流程记录
  getLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0f60bdujpot0mpht', 'get', config),
  // 按栏目发布
  postPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0qvcmjti', 'post', config),
  // 按栏目发布 新
  postpubByCol: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0qvcCzDpm', 'post', config, {
      timeout: 90000
    }),
  // 栏目预览
  viewColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0wjfxDpmvno', 'get', config),
  // 网站表格预览
  viewArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0qsfwjfx', 'get', config),
  // 添加到收藏夹
  postColumnwebs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sfm', 'post', config),
  // 取消添加到收藏夹
  postColumnwebsCancel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sfm0dbodfm', 'post', config),
  // 收藏栏目列表(我收藏的栏目)
  getFavorite: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0gbwpsjuf', 'get', config),
  // 栏目详情
  getColumnDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0dpmvnoEfubjm', 'get', config),
  // 回收站恢复
  getColumnsRestore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sftupsf', 'get', config),
  getViewBlocke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0cmpdl0wjfxCmpdl', 'get', config),
  // 首页订阅栏目默认设置
  postFormsData: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0f60gpsnt0ebub', 'post', config, vConfig),
  // 上传文件
  uploadResourceFile: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0vqmpbeSftpvsdfGjmf', 'post', config, vConfig),
  // 添加模板同步到子孙栏目操作
  synSonColTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbufsfmt0tzoTpoDpm', 'post', config),
  resourceUrlPath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0sftpvsdfVsmQbui', 'get', config),
  deleteResourceFile: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0efmfufSftpvsdfGjmf', 'post', config),
  getResourceDetial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0sftpvsdfEfujbm', 'get', config),
  postHasSamePath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0ufnqmbuf0ibtTbnfQbui', 'post', config),
}
